import { c as _c } from "react/compiler-runtime";
import { LoadingSpinner, MonacoProvider } from '@onefootprint/ui';
import { useRouter } from 'next/router';
import ErrorComponent from '@/components/error';
import TenantSwitcher from '@/components/tenant-switcher';
import Builder from './components/builder';
import useBuilderBootstrap from './hooks/use-builder-bootstrap';
import { BuilderProvider, useBuilder } from './store/provider';
const PercyBuilder = () => {
  const $ = _c(7);
  const {
    state
  } = useBuilder();
  const {
    error
  } = useBuilderBootstrap();
  const router = useRouter();
  const agentId = typeof router.query.id === "string" ? router.query.id : undefined;
  if (error) {
    let t0;
    if ($[0] !== error) {
      t0 = <BuilderShell><ErrorComponent error={error} /></BuilderShell>;
      $[0] = error;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== agentId || $[3] !== t0) {
      t1 = <TenantSwitcher id={agentId} Loading={_temp} onSwitched={_temp2}>{t0}</TenantSwitcher>;
      $[2] = agentId;
      $[3] = t0;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (!state.session) {
    let t0;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <BuilderShell><LoadingSpinner /></BuilderShell>;
      $[5] = t0;
    } else {
      t0 = $[5];
    }
    return t0;
  }
  let t0;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Builder />;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
};

// absolute inset-0 (not h-full) for the same reason as the Builder root in builder.tsx.
const BuilderShell = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="absolute inset-0 flex flex-col min-h-0 overflow-hidden items-center justify-center">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const PercyBuilderContainer = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MonacoProvider languageName="expression-editor"><BuilderProvider><PercyBuilder /></BuilderProvider></MonacoProvider>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PercyBuilderContainer;
function _temp() {
  return <BuilderShell><LoadingSpinner /></BuilderShell>;
}
function _temp2(_data, didSwitch) {
  if (didSwitch) {
    window.location.reload();
  }
}